export default __webpack_public_path__ + "static/media/gallery_20.434e876b.jpg";